import React, { useState, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { 
  ChevronLeft, 
  ChevronRight,
  ArrowRight,
  Globe,
  BarChart3,
  Users,
  Target,
  TrendingUp,
  Award,
  Bell,
  Smartphone,
  ShieldCheck,
  PieChart,
  RefreshCw
} from 'lucide-react';
import { Link } from 'react-router-dom';

const ServiceForPush = () => {
  const { scrollY } = useScroll();
  const [activeTab, setActiveTab] = useState(0);

  const services = [
    {
      icon: <Bell className="w-8 h-8" />,
      title: "Instant User Engagement",
      description: "Deliver real-time messages directly to users' devices, ensuring high visibility and immediate interaction—no waiting, no delays.",
    //   stat: "Learn More",
      color: "from-blue-600 to-cyan-500"
      
    },
    {
      icon: <ShieldCheck className="w-8 h-8" />,
      title: "100% Opt-In, Fraud-Free Traffic",
      description: "Connect with genuine, high-intent audiences who have voluntarily subscribed, eliminating bot traffic and maximizing authentic engagement.",
    //   stat: "Learn More",
      color: "from-purple-600 to-pink-500"
   
    },
    {
      icon: <Target className="w-8 h-8" />,
      title: "Personalized & Hyper-Targeted",
      description: " Leverage AI-driven targeting to customize notifications based on behavior, location, and preferences for relevance and higher conversion.",
    //   stat: "Learn More",
      color: "from-orange-500 to-red-500"
     
    },
    {
        icon: <Smartphone className="w-8 h-8" />,
        title: "Cross-Device Reach",
        description: "Seamlessly connect with users across mobile, desktop, and tablet screens, ensuring your brand stays top-of-mind anytime, anywhere.",
        // stat: "Learn More",
        color: "from-orange-500 to-red-500"
       
      },
      {
        icon: <Bell className="w-8 h-8" />,
        title: "Non-Intrusive Yet Unmissable",
        description: "Unlike pop-ups, push notifications appear naturally on screens without disrupting user experience—keeping high engagement. ",
        // stat: "Learn More",
        color: "from-purple-600 to-pink-500"

      },
      {
        icon: <TrendingUp className="w-8 h-8" />,
        title: "Maximum ROI",
        description: "Push ads deliver powerful results with minimal spend, offering high CTR and conversion potential without excessive ad budgets.",
        // stat: "Learn More",
        color: "from-blue-600 to-cyan-500"
      
      },
      {
        icon: <PieChart className="w-8 h-8" />,
        title: " Real-Time Performance Insights",
        description: "Track impressions, clicks, and conversions instantly with BidBox’s analytics dashboard—giving you full transparency and control over campaign performance.",
        // stat: "Learn More",
        color: "from-blue-600 to-cyan-500"
     
      },
      {
        icon: <BarChart3 className="w-8 h-8" />,
        title: "Seamless Integration ",
        description: "Push ads easily complement other digital ad formats, strengthening omnichannel marketing strategies and boosting overall campaign performance.",
        // stat: "Learn More",
        // link: "/geo-hyperlocal-targeting",
        color: "from-purple-600 to-pink-500"
   
      },
      {
        icon: <RefreshCw className="w-8 h-8" />,
        title: "Retargeting Capabilities",
        description: "Re-engage dormant visitors by delivering personalised and tailored messages, increasing the possibility of conversion without additional acquisition cost.",
        // stat: "Learn More",
        // link: "/lookalike-custom-audiences",
        color: "from-orange-500 to-red-500"
       
      },
      
  ];

  const features = [
    { title: "Dynamic Optimization", value: "93%", subtitle: "Campaign Success Rate" },
    { title: "Global Coverage", value: "200+", subtitle: "Countries Reached" },
    { title: "Client Satisfaction", value: "98%", subtitle: "Retention Rate" },
    { title: "ROI Improvement", value: "180%", subtitle: "Average Increase" }
  ];

  const statsY = useTransform(scrollY, [0, 300], [100, 0]);
  const statsOpacity = useTransform(scrollY, [0, 300], [0, 1]);

  return (
    <div className="w-full">
      {/* Services Section */}
      <section className="py-20 px-6 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.2 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Straight to Screens. Straight to Action

            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Leverage AI-powered programmatic solutions to deliver high-impact branding across premium digital platforms. Reach the right audience, at the right time, with precision and scale.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service, index) => (
                <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }} // Hover effect
                className="relative group"
              >
                <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:bg-gray-100">
                  <div className={`absolute inset-x-0 h-2 top-0 rounded-t-2xl bg-gradient-to-r ${service.color}`} />
                  <div className="mb-6 text-blue-600">{service.icon}</div>
                  <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
                  <p className="text-gray-600 mb-6">{service.description}</p>
                  <div className="flex items-center justify-between">
                  <Link to={service.link} className="text-lg font-semibold text-blue-600 hover:underline">
    {service.stat}
  </Link>
                  </div>
                </div>
              </motion.div>
              
            //   <motion.div
            //     key={index}
            //     initial={{ opacity: 0, y: 20 }}
            //     whileInView={{ opacity: 1, y: 0 }}
            //     viewport={{ once: true }}
            //     transition={{ duration: 0.6, delay: index * 0.2 }}
            //     className="relative group"
            //   >
            //     <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
            //       <div className={`absolute inset-x-0 h-2 top-0 rounded-t-2xl bg-gradient-to-r ${service.color}`} />
            //       <div className="mb-6 text-blue-600">{service.icon}</div>
            //       <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
            //       <p className="text-gray-600 mb-6">{service.description}</p>
            //       <div className="flex items-center justify-between">
            //         <span className="text-lg font-semibold">{service.stat}</span>
            //         <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transition-colors" />
            //       </div>
            //     </div>
            //   </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      {/* <motion.section 
        style={{ y: statsY, opacity: statsOpacity }}
        className="py-20 px-6 bg-gradient-to-r from-blue-600 to-purple-600"
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="text-center text-white"
              >
                <div className="text-5xl font-bold mb-2">{feature.value}</div>
                <div className="text-xl font-semibold mb-1">{feature.title}</div>
                <div className="text-blue-200">{feature.subtitle}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section> */}
    </div>
  );
};

export default ServiceForPush;